export { default as Image, type ImageProps } from './lib/image';
